import { render, staticRenderFns } from "./StockInoutStatistics.vue?vue&type=template&id=38e8c73e&"
import script from "./StockInoutStatistics.vue?vue&type=script&lang=ts&"
export * from "./StockInoutStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports